export default "__VITE_ASSET__CsSyoTyy__"